import { user, i18n, Trans, http, helper, twoFactorPolicy } from 'services'

export function beforeRouteUpdateMixin () {
  return {
    beforeRouteUpdate (to, from, next) {
      const { asyncData } = this.$options
      console.log('beforeRouteUpdate', this.$options);

      if (asyncData) {
        asyncData({
          app: this.$root,
          router: this.$router,
          store: this.$store,
          route: to,
          i18n,
        }).then(() => {
          next()
        }).catch((e) => {
          next(e)
        })
      } else {
        next()
      }
    }
  }
}

export function beforeRouteEnterMixin () {
  return {
    async beforeCreate () {
      let route = null;
      try {
        if (this.$route) {
          await Trans.checkLang(this.$route)
          if (this.$route.name != 'login') {
            route =  this.$route.fullPath;
            if (user.getToken()) {
              helper.stopUserValidationTimer();
              helper.startUserValidationTimer();
            }
          }  
        }
        if ((!user.getToken() || !user.hasFrontAccess()) && !this.$route.meta.public) {
          if (!user.hasFrontAccess() && user.getToken()) {
              http.post(`users/auth/logout`).then((res) => {
            });
          }
          this.$router.replace({
            name: 'login',
            query: {
              goto: route
            }
          });
        } else if (
          user.hasFrontAccess() &&
          twoFactorPolicy.requiresSetup(user.getUser()) &&
          this.$route.name !== 'profile.security'
        ) {
          this.$router.replace({ name: 'profile.security' });
        }
      } catch (e) {

      }

    }
  }
}

export function lodash () {
  return {
    computed: {
      _ () {
        return _;
      }
    }
  };
}
